import FlowButton from './FlowButton'
import LockUnlockButton from './LockUnlockButton'
import { useAppContext } from '../contexts/AppContext'
import CopilotButton from './CopilotButton'

export default function Head() {
  const {
    data,
    update,
    settings: { hideFlow, hideLock },
  } = useAppContext()

  const handleLock = () => update(data, 'isLocked', !data.isLocked)

  return (
    <div className="sticky z-10 top-0 flex justify-between items-center bg-background">
      <div>{!hideFlow && <FlowButton />}</div>

      <div className="flex items-center">
        <CopilotButton />
        {!hideLock && <LockUnlockButton isLocked={!!data.isLocked} onClick={handleLock} />}
      </div>
    </div>
  )
}
